import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { DEFAULT_CATALOG_STRING } from '@/utils/constants';

@Component({
    name: 'sub-content-filter',
    components: {
        'material-icon': GoogleMaterialIcon,
    },
})

export default class SubContentFilter extends Vue {


    // -----------------------------------------------------------------------
    // Properties

    @Prop()
    private activeActivity: any;

    private getContent: any = [];

    private fltkey: any = {resource: 'flt.resourceFormat', question : 'flt.questionType'};

    private selectedItems: any = [];

    @Watch('activeActivity', {deep: true})
    private onChangeContent(value: any) {
        this.selectedItems = [];
        this.getContent = DEFAULT_CATALOG_STRING[value.key];
    }
    // --------------------------------------------------------------------------
    // Hooks
    private created() {
            this.onChangeContent(this.activeActivity);
    }

    // -------------------------------------------------------------------------
    // Actions
    private selectSubFilter(key: string) {
         if (!this.checkingExisting(key)) {
            this.selectedItems.push(key);
         } else {
            this.selectedItems = this.selectedItems.filter((item: any) => item !== key);
         }
         this.onLoad();
    }

    private checkingExisting(key: string) {
        return this.selectedItems.indexOf(key) !== -1;
    }

    private onLoad() {
       const params: any = {};
       params[this.fltkey[this.activeActivity.key]] = this.selectedItems.toString();
       this.$root.$emit('evenBusCatalogSubFlt', params);
    }
}
